// copied from https://edvins.io/react-text-to-speech by Edvins Antonovs, 230405
import React, { useState, useEffect, useContext } from "react";
import { ShopperContext } from '../context/shopper';
import * as Constants from '../constants';
import { useLookups } from "../hooks/useSkuUtils";
import AudioPlayButtons from "../components/AudioPlayButtons";

const TextToSpeech = ({ text }) => {
  const [isPaused, setIsPaused] = useState(false);
  const [utterance, setUtterance] = useState(null);
  const [voice, setVoice] = useState(null);

  const [playWasClicked, setPlayWasClicked] = useState(false);

  const {
    shopper,
    latestPausedText,
    resetLatestPausedText,
  } = useContext(ShopperContext);

  const { lookup_voice_info } = useLookups();
  const voiceInfo =
    lookup_voice_info({voice_term: shopper.help_voice }) ||
      Constants.HELP_VOICE_DATA;
  // e.g. Martha|en-GB|female  ||  Google|en-US|female

// TODO: In development, had a stray error where 'shopper.help_voice' was null 
// during 'Signup', and it caused a crash. The below could fix, but I could not
// reproduce the error, so I'm leaving current assignment as is.
//   const voiceInfo =
// shopper.help_voice
//   ? (
//     lookup_voice_info({voice_term: shopper.help_voice }) ||
//       Constants.HELP_VOICE_DATA
//   // e.g. Martha|en-GB|female  ||  Google|en-US|female
//     )
//   : Constants.HELP_VOICE_DATA;
//   // Google|en-US|female

  const ttsRate = parseFloat(shopper.tts_rate || Constants.TIPPY_TTS_RATE); // 1

  useEffect(() => {
    const synth = window.speechSynthesis;

   const handleVoicesChanged = () => {
    const voices = synth.getVoices();
    // console.log('voice count', voices.length);  // 210
    // console.log('voices', voices[198]);  // lang: hi-IN
    // console.log('voices', voices.map((v, i) => `${i}, ${v.name}`));
    const [
      ttsName, ttsLocale,  // ttsSex
    ] = voiceInfo.split("|");
    // console.log('tts ttsName', ttsName);
    // console.log('tts ttsLocale', ttsLocale);

    const u = new SpeechSynthesisUtterance(text);
    // console.log('tts u', u);

    u.lang = ttsLocale;
    // 'lang' is a separate knob from 'voice'. Engines consult it when
    // reading numbers, dates, and abbreviations, and they fall back on
    // it to choose a voice when 'utterance.voice' is left unset - which
    // happens below whenever the shopper's saved voice is not installed
    // on this device (the 'find' returns undefined and we assign that).
    // https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesisUtterance

    setUtterance(u);

    setVoice(
      voices.find((v) =>  v.name.includes(ttsName)  &&  v.lang === ttsLocale)
    );
   }
   
    // In case voices are already loaded:
    handleVoicesChanged();
  
    // Listen for voices loading:
    synth.addEventListener('voiceschanged', handleVoicesChanged);

    return () => {
      synth.removeEventListener('voiceschanged', handleVoicesChanged);
      synth.cancel();
    };
  }, [text, voiceInfo]);

  const handlePlay = (e) => {
    // prevent the click from being picked up as an instruction to Submit:
    e.preventDefault();

    const synth = window.speechSynthesis;
    // console.log('handlePlay')
    // console.log('tts isPaused', isPaused)
    // console.log('tts text', text)
    // console.log('tts synth', synth);
    // // console.log('tts utterance', typeof utterance);
    // console.log('tts utterance', utterance);
    // console.log('tts utt.text', utterance.text);
    // console.log('tts playWasClicked', playWasClicked);

    // if this paragraph's Play button has not been clicked until now, then
    // emit 'cancel' to clear out any other object's audio, proceed to play.
    if (! playWasClicked
      ||  latestPausedText !== utterance.text
      // Or,if some text's playback was paused (meaning that it's in some global
      // register (?) waiting to resume playing when someone clicks Play), then
      // 'cancel' the other audio and start playback from beginning of this text
    ) {
      synth.cancel();
    }

    if (isPaused || !playWasClicked) {
      // if Play button was in 'paused' state then let's 'resume'.
      // if Play button had not been clicked until just now, invoking 'resume'
      // insures getting focus here.
      synth.resume();
    }

    utterance.voice = voice;
    utterance.rate  = ttsRate;
    synth.speak(utterance);

    setIsPaused(false);
    setPlayWasClicked(true);
    // The first time that Play is clicked, setting this to 'true' matters.
    // All times thereafter, the reset to 'true' is basically a no-op.
  };

  const handlePause = (e) => {
    e.preventDefault();
    const synth = window.speechSynthesis;
    resetLatestPausedText(utterance.text);
    // A state variable in context tracks which text was the latest to be
    // paused, so update that variable now.
    // Later, when shopper clicks Play, we'll check that we are processing the
    // same text as was paused here. If we paused some other track, the Play
    // action will 'cancel' it and play the correct audio from the beginning.
    // TODO: Investigate - seems like with each pause, the pause happens
    // properly but a complete replay is also scheduled. So, pausing playback
    // at two different points causes two extra replays of that same text. Hmm.

    synth.pause();

    setIsPaused(true);
  };

  const handleStop = () => {
    const synth = window.speechSynthesis;

    synth.cancel();

    setPlayWasClicked(false);
    setIsPaused(false);
  };

  return (
    <>
      <>&nbsp;</>
      <AudioPlayButtons
        handlePlay     = {handlePlay}
        handlePause    = {handlePause}
        handleStop     = {handleStop}
        isPaused       = {isPaused}
        playWasClicked = {playWasClicked}
      />
    </>
  );
};

export default TextToSpeech;
